import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        // The 44px floor below `md` is a minimum, not a height: it never shrinks a field that a
        // screen has already made taller, and it leaves the desktop density alone.
        'h-9 w-full rounded-control border border-border-subtle bg-surface px-3 text-sm text-heading transition-colors max-md:min-h-11',
        'placeholder:text-muted hover:border-border-strong',
        'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-muted',
        'aria-invalid:border-danger-fill aria-invalid:hover:border-danger-fill',
        className,
      )}
      {...props}
    />
  )
}
